(($) => {
    `use strict`;
    $(document).ready(() => {

        let  lazysizes = require('lazysizes');

        $('.shopping-cart-popover, .click-no-close').on('click', (event) => {
            event.stopPropagation();
        });

        // Add support for swiping.
        // @todo Remove it when this issue will be fixed - https://github.com/twbs/bootstrap/issues/17118
        const $carousel = $('.carousel');
        $carousel.on('touchstart', function (event)  {
            const xClick = event.originalEvent.touches[0].pageX;

            $(this).one('touchmove', function (event) {
                const xMove = event.originalEvent.touches[0].pageX;
                if (Math.floor(xClick - xMove) > 5) {
                    $(this).carousel('next');
                } else if (Math.floor(xClick - xMove) < -5) {
                    $(this).carousel('prev');
                }
            });

            $carousel.on('touchend', function () {
                $(this).off('touchmove');
            });

        });

        // If it's mobile screen (Bootstraps's less than md) - open top user menu
        if (window.innerWidth < 768) {
            $('#collapsed-menu').on('show.bs.collapse', () => {
                const $userMenu = $('#top-user-menu');
                if ($userMenu.length === 1) {
                    $userMenu.toggle();
                }
            });
        }

        function toogleOrderId(show = true) {
            if (show === true) {
                $('#orderId').attr("required","");
                $('#orderId').parent().css("display","");
            } else {
                $('#orderId').removeAttr("required");
                $('#orderId').parent().css("display","none");
            }

        }

        function toogleBusinessCategory(show = true) {
            if (show === true) {
                $('#businessCategory').attr("required","");
                $('#businessCategory').parent().css("display","");

                $('#businessName').attr("required","");
                $('#businessName').parent().css("display","");

                $('#businessAddress').attr("required","");
                $('#businessAddress').parent().css("display","");

                $('#businessPhone').attr("required","");
                $('#businessPhone').parent().css("display","");

                $('#businessWebsite').attr("required","");
                $('#businessWebsite').parent().css("display","");
            } else {
                $('#businessCategory').removeAttr("required");
                $('#businessCategory').parent().css("display","none");

                $('#businessName').removeAttr("required");
                $('#businessName').parent().css("display","none");

                $('#businessAddress').removeAttr("required");
                $('#businessAddress').parent().css("display","none");

                $('#businessPhone').removeAttr("required");
                $('#businessPhone').parent().css("display","none");

                $('#businessWebsite').removeAttr("required");
                $('#businessWebsite').parent().css("display","none");
            }
        }

        function toogleCustomComment(show = true) {
            if (show === true) {
                $('#customComment').attr("required","");
                $('#customComment').parent().css("display","");
            } else {
                $('#customComment').removeAttr("required");
                $('#customComment').parent().css("display","none");
            }
        }

        $('.option-box').on('click', function () {
            $(this).addClass('active-box').siblings().removeClass('active-box');

            // Add reason index to hidden input
            const idx = $(this).attr('index');
            $("#reason").val(idx);
            switch(idx) {
                case '1':
                    toogleOrderId(true);
                    toogleBusinessCategory(false);
                    toogleCustomComment(false);
                    break;
                case '2':
                    toogleOrderId(true);
                    toogleBusinessCategory(false);
                    toogleCustomComment(false);
                    break;
                case '3':
                    toogleOrderId(false);
                    toogleBusinessCategory(true);
                    toogleCustomComment(false);
                    break;
                case '4':
                    toogleOrderId(false);
                    toogleBusinessCategory(false);
                    toogleCustomComment(true);
                    break;
                default:
                    toogleOrderId(true);
                    toogleBusinessCategory(false);
                    toogleCustomComment(false);
            }

        });

        $(".option-box[index='1']").trigger("click");

    });

})(jQuery);
